import Crud from '../views/Resposta/Crud'
import Entity from '../views/Resposta/Add'

let routes = {
    path: '/respostas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/respostas/add',
            name: 'NewResposta',
            component: Entity
        },
        {
            path: '/respostas/edit/:id?',
            name: 'EditResposta',
            component: Entity
        },
        {
            path: '/respostas',
            name: 'list-respostas',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Respostas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
